var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qr-code"},[_c('img',{attrs:{"src":_vm.qr,"alt":_vm.itemName}}),_vm._v(" "),_c('a',{attrs:{"href":_vm.qr,"download":_vm.itemName}},[_vm._v("download")])])}
var staticRenderFns = []

export { render, staticRenderFns }